import React from "react";
import PropTypes from "prop-types";

export default function InsiderIcon({title}) {
  return (
    <svg className="insider-icon icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
      <title>{title}</title>
      <g>
        <path d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z"/>
        <path className="tick" d="M34.602,14.602L21,28.199l-5.602-5.598l-2.797,2.797L21,33.801l16.398-16.402L34.602,14.602z"/>
      </g>
    </svg>
  );
}

InsiderIcon.propTypes = {
  title: PropTypes.string.isRequired
};


// WEBPACK FOOTER //
// ./modules/Common/components/svg/CheckIcon.js